import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import React from 'react'

const useStyles = makeStyles(() => ({
    iconButtonStyle: {
        padding: 0,
        '&.MuiSvgIcon-fontSizeSmall': {
            fontSize: pxToRem(18),
        },
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
}))

export interface DeletePillsProps {
    onDeleteOption?: () => void
    disabled?: boolean
    isInsertText?: boolean
    htmlColor?: string
}

const DeletePills: React.FC<DeletePillsProps> = ({
    onDeleteOption,
    disabled,
    isInsertText,
    htmlColor,
}) => {
    const classes = useStyles()

    const handleDeleteClick = React.useCallback(
        (event: React.MouseEvent<HTMLButtonElement>) => {
            if (isInsertText) {
                onDeleteOption?.()
            } else {
                if (!disabled) onDeleteOption?.()
            }
            event.stopPropagation()
        },
        [onDeleteOption, disabled, isInsertText]
    )

    return (
        <IconButton
            onClick={handleDeleteClick}
            size="small"
            className={classes.iconButtonStyle}
            data-testid={
                isInsertText ? 'deleteInsertTextIcon' : 'deleteEditorOption'
            }
            disableRipple={true}
        >
            <HighlightOffIcon
                fontSize="small"
                className={classes.iconButtonStyle}
                htmlColor={htmlColor}
            />
        </IconButton>
    )
}

export default DeletePills
